import React from 'react';
import { Icon } from 'antd';
import classnames from 'classnames';
import queryString from 'query-string';

import Status from 'components/RequestStatus/Status';
import RequestTitle from 'components/Userrequest/RequestTitle';
import ActivitiesDates from 'components/Userrequest/ActivitiesDates';
import styles from './userrequestListColumns.module.scss';

function getStatusFilters (isUser) {
  const status = [
    { text: 'En évaluation', value: 200 },
    { text: 'Acceptée', value: 300 },
    { text: 'Refusée', value: -1 },
    { text: 'Annulée', value: -100 },
  ];
  if (isUser) {
    status.push({ text: 'Brouillon', value: 100 });
  }
  return status;
}

function getStatusFilteredValue (location) {
  const { state__in: stateIn } = queryString.parse(location);
  return stateIn ? stateIn.split(',') : undefined; // eslint-disable-line camelcase
}

const getColumns = (isUser, location) => [{
  title: 'Nom',
  dataIndex: 'properties.title',
  key: 'properties.title',
  width: 230,
  render: (title, userrequest) =>
    <RequestTitle title={title} userrequest={userrequest} />,
  sorter: true,
}, {
  title: 'Statut',
  dataIndex: 'state',
  width: 230,
  key: 'state',
  render: (user, userrequest) => (
    <Status
      userrequest={userrequest}
    />
  ),
  filters: getStatusFilters(isUser),
  filteredValue: getStatusFilteredValue(location),
  align: 'center',
  sorter: true,
}, {
  title: 'Date',
  dataIndex: 'properties.activities',
  key: 'properties.firstEventDate',
  align: 'center',
  render: activities => <ActivitiesDates activities={activities} />,
  sorter: true,
}, {
  title: 'Numéro',
  dataIndex: 'id',
  key: 'id',
  render: id => id,
  sorter: true,
  align: 'center',
}, {
  title: 'Message',
  dataIndex: 'message',
  key: 'message',
  align: 'center',
  render: (user, userrequest) => (
    <Icon
      className={classnames({
        [styles.icon]: true,
        [styles.notification]: userrequest.has_new_comments,
      })}
      type="mail"
    />
  ),
}];

export default getColumns;



// WEBPACK FOOTER //
// ./src/helpers/userrequestListColumns.js